export class Configuration {
  public apiAddress: string;
  public reportViewerAddress: string;
  public webAppAddress: string;
  public showDashboards: boolean;
  public tokenExpireInSec: number;
  public showCreateActBtn: boolean;
  public version: string;
  public companyLogos: Object[];
}
